<template>
  <div class="container">
    <div class="help-title">
      <span>{{ $t("help.usageTitle") }}</span>
    </div>
    <div class="guide-container shadow">
      <div>
        <!-- <div class="help-title">
          <span>{{ $t("help.usageInfo") }}</span>
        </div> -->
        <div class="help-info">
          <img src="../../assets/help-icon-01.png" />
          <span>{{ $t("help.usageBuy") }}</span>
        </div>
        <div class="help-info">
          <img src="../../assets/help-icon-02.png" />
          <!-- <span>{{ $t("help.usageCheck") }}</span> -->
          <i18n path="help.usageCheck" tag="span">
            <br />
          </i18n>
        </div>
        <div class="help-info">
          <img src="../../assets/help-icon-03.png" />
          <span>{{ $t("help.usageExchange") }}</span>
        </div>
        <div class="help-info">
          <img src="../../assets/help-icon-04.png" />
          <span>{{ $t("help.usageUsed") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "./help-page.scss";
</style>
